
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Registration = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>Registration</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Admission</li>
                    <li>|</li>
                    <li>Registration</li>
                </ul>
            </div>
            <div className="inner_page uniform_section">
                <div className="container">
                    <div className="row">
                         
                        
                        <div className="col-md-4">
                            <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/opportunity.jpg" alt="st francis school, Amritsar" className="img-fluid bordered_img" /></LazyLoad>
                        </div>
                        <div className="col-md-8">
                            <p>There shall be written test followed by an interview for admission to any class except for the Nursery Class. Selection will be strictly on merit, subject to the availability of seats in each class.</p>
                            <p>The decision the school authorities regarding registration and admission will be final. There is no specific syllabus for the Entrance test to any class. However, the criterion is to have the necessary knowledge based on which the students can continue his/her studies as per the <span>ICSE syllabus,</span> in the class to which the admission is sought. The test will be conducted according to the standard of the school, based on the subjects taught in the previous classes.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Registration
